/* eslint-disable */
import * as Types from './types';

export type NailArtProductGroupsFragment = { __typename?: 'ComponentsNailArtProductGroup', title?: string | null, productsCollection?: { __typename?: 'ComponentsNailArtProductGroupProductsCollection', items: Array<{ __typename?: 'Product', handle?: string | null, title?: string | null, id?: string | null, shopifyId?: string | null } | null> } | null };

export declare const NailArtProductGroupsFragment: import("graphql").DocumentNode;
export const NailArtProductGroupsFragmentDoc = /*#__PURE__*/ `
    fragment NailArtProductGroupsFragment on ComponentsNailArtProductGroup {
  title
  productsCollection {
    items {
      handle
      title
      id
      shopifyId
    }
  }
}
    `;